(function () {
  'use strict';

  var SECTION_ID = 'product-card-api';
  var GRID_CLASS = 'grid-list products-list products-list--list-standard f-grid f-grid--gap-extra-small f-grid--row-gap-medium';
  var cssInjected = false;

  function init() {
    if (!document.body.classList.contains('article-template')) return;

    var cards = document.querySelectorAll('[data-url]');
    if (!cards.length) return;

    /* Inject minimal loading styles */
    var style = document.createElement('style');
    style.textContent = '.pce-loading{display:flex;align-items:center;justify-content:center;min-height:120px}.pce-spinner{width:24px;height:24px;border:2px solid rgba(var(--color-foreground),.15);border-top-color:rgb(var(--color-foreground));border-radius:50%;animation:pce-spin .6s linear infinite}@keyframes pce-spin{to{transform:rotate(360deg)}}.pce-error{text-align:center;padding:1.6rem;opacity:.6}.rte #ProductsList,.article__content #ProductsList{all:initial;display:block!important;font-family:var(--font-body-family);color:rgb(var(--color-foreground))}.rte #ProductsList *,.article__content #ProductsList *{font-style:inherit;letter-spacing:inherit}.rte #ProductsList a,.article__content #ProductsList a{text-decoration:none;color:inherit}.rte #ProductsList p,.article__content #ProductsList p,.rte #ProductsList h1,.rte #ProductsList h2,.rte #ProductsList h3,.rte #ProductsList h4,.rte #ProductsList h5,.rte #ProductsList h6,.article__content #ProductsList h1,.article__content #ProductsList h2,.article__content #ProductsList h3,.article__content #ProductsList h4,.article__content #ProductsList h5,.article__content #ProductsList h6{margin:0;padding:0}.rte #ProductsList img,.article__content #ProductsList img{display:block;max-width:100%;height:auto}.rte #ProductsList ul,.rte #ProductsList ol,.article__content #ProductsList ul,.article__content #ProductsList ol{list-style:none;margin:0;padding:0}.rte #ProductsList a.btn--primary,.article__content #ProductsList a.btn--primary{color:rgb(var(--color-button-text))}@media(hover:hover) and (pointer:fine){.rte #ProductsList a.btn--primary:hover,.article__content #ProductsList a.btn--primary:hover{color:rgb(var(--color-button))}}';
    document.head.appendChild(style);

    /* Group consecutive [data-url] siblings */
    var groups = [];
    var current = [];

    cards.forEach(function (el, i) {
      current.push(el);
      var next = cards[i + 1];
      var isSibling = next && el.nextElementSibling === next;
      if (!isSibling) {
        groups.push(current);
        current = [];
      }
    });

    groups.forEach(function (group) {
      var grid = document.createElement('div');
      grid.id = 'ProductsList';
      grid.className = GRID_CLASS;
      grid.setAttribute('style', '--f-columns-mobile: 2; --f-columns-md: 3; --f-columns-lg: 4; --f-columns-xl: 4;');
      grid.setAttribute('data-layout', 'list');

      group[0].parentNode.insertBefore(grid, group[0]);

      group.forEach(function (el) {
        grid.appendChild(el);
      });

      group.forEach(function (el) {
        fetchCard(el);
      });
    });
  }

  function fetchCard(el) {
    var rawUrl = el.getAttribute('data-url');
    if (!rawUrl) return;

    var productPath = '';
    try {
      var url = new URL(rawUrl, window.location.origin);
      productPath = url.pathname;
    } catch (e) {
      productPath = rawUrl;
    }

    if (productPath.indexOf('/products/') === -1) return;

    el.classList.add('pce-loading');
    el.innerHTML = '<div class="pce-spinner"></div>';

    fetch(productPath + '?section_id=' + SECTION_ID)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        /* Inject stylesheets from response (once) */
        if (!cssInjected) {
          doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
            var href = link.getAttribute('href');
            if (href && !document.querySelector('link[href="' + href + '"]')) {
              document.head.appendChild(link.cloneNode(true));
            }
          });
          cssInjected = true;
        }

        /* ========== [カスタマイズ追記 2026-07-10] ==========
           「カートに追加」ボタン（クイック追加フォーム）を、
           決済ページに直行する Cart Permalink 形式の「購入に進む」リンクに差し替える。
           URL形式: /cart/{バリアントID}:1?channel=buy_button
           バリアントIDはフォーム内の input[name="id"] から取得。
           売り切れ（disabled）はそのまま維持。
           複数バリアント商品の「オプションを選択」ボタンも対象外（従来動作を維持）。
           =================================================== */
        convertAtcToBuyLink(doc);

        /* Extract f-column from inside shopify-section wrapper */
        var fColumn = doc.querySelector('.f-column');
        if (fColumn) {
          el.replaceWith(fColumn);
        } else {
          el.classList.remove('pce-loading');
          el.outerHTML = doc.body.innerHTML;
        }
      })
      .catch(function () {
        el.classList.remove('pce-loading');
        el.innerHTML = '<p class="pce-error text-subtext">商品情報を取得できませんでした</p>';
      });
  }

  /* ========== [カスタマイズ追記 2026-07-10] ==========
     カートに追加 → 購入に進む（決済直行 Cart Permalink）変換
     =================================================== */
  function convertAtcToBuyLink(root) {
    var forms = root.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');

    forms.forEach(function (form) {
      var idInput = form.querySelector('input.product-variant-id, input[name="id"]');
      var button = form.querySelector('button[name="add"]');
      if (!idInput || !button) return;

      /* 売り切れはボタンのまま（disabled表示を維持） */
      if (button.disabled || idInput.disabled) return;

      var link = document.createElement('a');
      link.className = button.className;
      link.href = '/cart/' + idInput.value + ':1?channel=buy_button';
      link.setAttribute('aria-label', '購入に進む');
      link.innerHTML = '<span class="btn__text">購入に進む</span>';

      button.replaceWith(link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();